export const SEARCH_TERM_SET = 'SEARCH_TERM_SET';

export const setSearchTerm = (searchTerm) => ({
  type: SEARCH_TERM_SET,
  searchTerm
});



// WEBPACK FOOTER //
// ./src/redux/actions/search.js